<template>
	<div class="upload-anexos relative">
		<h4 v-if="!hiddenLabel" class="subtitle mt-10 mb-4 font-bold">Anexos</h4>
		<vs-alert
			color="success"
			:active.sync="successAlert"
			icon-pack="feather"
			icon="icon-check"
			closable
			close-icon="icon-x"
			class="text-left"
		>
			<p>Anexos enviados com sucesso!</p>
		</vs-alert>

		<form id="form-enviar-anexos">
			<ld-upload
				name="anexos"
				class="w-full"
				accept=""
				:fotos.sync="files"
			>
				<template v-slot:text>
					<div class="flex flex-col items-center pointer-events-none">
						<feather-icon
							icon="UploadCloudIcon"
							svgClasses="h-12 w-12"
						/>
						<h3 class="text-center text-gray-600 text-xl mt-3">
							Arraste aqui o anexo ou <br />
							clique para selecionar.
						</h3>
					</div>
				</template>
			</ld-upload>
		</form>

		<vs-table v-show="anexosObj && anexosObj.length > 0" :data="anexosObj">
			<template slot="thead">
				<vs-th class="w-24 index">#</vs-th>
				<vs-th>Anexo</vs-th>
				<vs-th>Progresso</vs-th>
				<vs-th class="w-24 acoes">Ações</vs-th>
			</template>

			<template slot-scope="{ data }">
				<tbody class="table-anexos-body">
					<vs-tr
						:data="tr"
						:key="indextr"
						v-for="(tr, indextr) in data"
						:class="{ 'has-error': tr.hasError }"
					>
						<vs-td class="index">
							<p class="font-medium truncate">
								{{ indextr + 1 }}
							</p>
						</vs-td>

						<vs-td>
							<p class="font-medium truncate">
								{{ tr.anexo }}
							</p>
						</vs-td>

						<vs-td>
							<vs-progress
								:percent="Number(tr.progresso)"
								:color="tr.hasError ? 'danger' : getPopularityColor(Number(tr.progresso))"
								class="shadow-md"
							/>
							<h4
								v-show="!tr.hasError && flat"
								class="text-base text-center stroke-current"
								:class="{'inline': !tr.hasError && flat}"
							>
								{{ parseInt(tr.progresso) }}%
							</h4>
							<h4
								v-show="!tr.hasError && !flat"
								class="text-base stroke-current"
								:class="{'inline': !tr.hasError && !flat}"
							>
								<span class="text-enviando-anexo">
									{{
										tr.progresso == 100
											? "Enviado - "
											: "Enviando... - "
									}}
								</span>
								{{ parseInt(tr.progresso) }}%
							</h4>
							<h4
								v-show="tr.hasError && !flat"
								class="text-danger text-base stroke-current"
							>
								Falha no envio.
							</h4>
						</vs-td>

						<vs-td class="w-24">
							<feather-icon
								v-show="tr.progresso == 100 && (tr.pk || tr.hasError)"
								icon="TrashIcon"
								class="ml-3 mt-3"
								svgClasses="w-5 h-5 hover:text-danger stroke-current"
								@click.stop="deleteAnexo(tr)"
							/>
						</vs-td>
					</vs-tr>
				</tbody>
			</template>
		</vs-table>
		<div class="flex justify-between pt-3">
			<ld-button
				v-if="showEnviarAnexos"
				:disabled="!anexosObj || (anexosObj && !anexosObj.length) || (anexosObj && anexosObj.length != anexosCriados.length)"
				color="primary"
				class="w-full"
				@click="() => enviarAnexos()"
			>
				Enviar anexos
			</ld-button>
		</div>
	</div>
</template>

<script>
import EncryptHelper from "../../../../../../helpers/EncryptHelper";
import ErrorHelper from "../../../../../../helpers/ErrorHelper";
import ScrollHelper from "../../../../../../helpers/ScrollHelper";
import Empresa from "../../../../../../models/Empresa";
import Prazo from "../../../../../../models/Prazo";

export default {
	name: "Anexos",
	data() {
		return {
			anexo: null,
			anexosMap: {},
			anexosCriados: [],
			successAlert: false
		};
	},
	props: {
		anexos: {
			required: true,
			type: Array
		},
		hiddenLabel: {
			default: false
		},
		flat: {
			default: false
		},
		showEnviarAnexos: {
			default: false
		},
		prazoPk: {
			type: String
		},
		onSend: {
			type: Function
		},
	},
	computed: {
		empresaPk() {
			try {
				return this.$route.params.empresaPk;
			} catch (error) {
				return null;
			}
		},
		files: {
			get() {
				return this.anexo;
			},
			set(value) {

				if (value && value.length) {
					const loadingAdicionarAnexo = this.$vsloading({
						container: ".upload-anexos .ld-upload",
						color: "#000000",
						backgroundColor: "#ffffffba",
						opacity: 1,
						width: 44,
						height: 44
					});

					const files = [...value];
					files.forEach((file, index) => {
						setTimeout(() => {
							this.remover();
							this.addAnexo(file);

							if (index == (files.length - 1)) {
								loadingAdicionarAnexo.hide();
							}

						}, 500);
					});
				}
			}
		},
		anexosObj: {
			get() {
				return Object.values(this.anexosMap);
			},
			set(value) {
				this.$emit("update:anexos", value);
			}
		}
	},
	methods: {
		async setInitialAnexos() {
			if (this.anexos && this.anexos.length) {
				const files = [];

				for (const anexo of this.anexos) {
					const anexoFileResponse = await Prazo.baixarAnexo(anexo.arquivo);
					const blob = new Blob([anexoFileResponse.request.response]);
					const file = new File([blob], anexo.nome_original, { lastModified: new Date().getTime() });
					files.push(file);
				}

				this.files = files;
			}
		},
		remover() {
			const $buttonClose = this.$el.querySelector(
				".upload-preview-close"
			);
			if ($buttonClose) {
				$buttonClose.click();
			}
		},
		async addAnexo(anexo) {
			const id = EncryptHelper.encrypt("key");
			try {
				this.successAlert = false;
				this.$set(this.anexosMap, id, {
					id,
					pk: null,
					anexo: anexo.name,
					progresso: 0,
					hasError: false
				});

				setTimeout(() => this.scrollToEndAnexos(), 100);

				const anexoResponse = await Empresa.enviarAnexo(
					this.empresaPk,
					anexo,
					eventProgress => {

						if (this.anexosMap[id].progresso) {
							setTimeout(() => {
								this.anexosMap[id].progresso =
									(eventProgress.loaded / eventProgress.total) * 100;
							}, 1000);
						} else {
							this.anexosMap[id].progresso =
									(eventProgress.loaded / eventProgress.total) * 100;
						}
					}
				);

				this.anexosCriados.push(anexoResponse.pk);

				this.anexosMap[id].pk = anexoResponse.pk;
				this.anexosMap[id].hasError = false;

				this.anexosObj = Object.values(this.anexosMap);

			} catch (error) {
				console.error(error);
				if (id) {
					this.anexosMap[id].progresso = 100;
					this.anexosMap[id].hasError = true;
				}
			}
		},
		async enviarAnexos() {
			const loadingEnviarAnexos = this.$vsloading({
				container: ".upload-anexos",
				color: "#000000",
				backgroundColor: "#ffffffba",
				opacity: 1,
				width: 44,
				height: 44
			});
			try {
				await Prazo.enviarAnexos(
					this.empresaPk,
					this.prazoPk,
					this.anexosObj
				);
				this.anexosMap = {};
				this.anexosCriados = [];
				this.$emit("update:anexos", this.anexosObj);
				this.successAlert = true;
				setTimeout(() => (this.successAlert = false), 2000);

				if (this.onSend) {
					this.onSend();
				}
			} catch (error) {
				ErrorHelper.renderFormError("#form-enviar-anexos", error);
			} finally {
				loadingEnviarAnexos.hide();
			}
		},
		deleteAnexo(anexo) {
			try {
				Empresa.excluirAnexo(this.empresaPk, anexo.pk);
			} catch (error) {
				console.error(error);
			} finally {

				const indexAnexoCriado = this.anexosCriados.findIndex(anexoCriado => anexoCriado === anexo.pk);

				if (indexAnexoCriado >= 0) {
					this.anexosCriados.splice(indexAnexoCriado, 1);
				}

				this.$delete(this.anexosMap, anexo.id);
				this.$emit("update:anexos", this.anexosObj);
			}
		},
		getPopularityColor(num) {
			if (num > 90) return "primary";
			if (num >= 50) return "warning";
			if (num < 50) return "danger";
			return "primary";
		},
		scrollToEndAnexos() {
			const $tableBody = this.$el.querySelector(
				".upload-anexos .vs-con-tbody"
			);

			if ($tableBody) {
				ScrollHelper.scrollTo($tableBody, $tableBody.scrollHeight, 300);
			}
		},
	},
	mounted() {
		this.setInitialAnexos();
	}
};
</script>

<style lang="scss">
.upload-anexos {
	.upload-preview {

		button {
			top: 100%;
		}
	}

	.upload-input {
		background-color: #f8f8fa !important;
	}

	.vs-con-table {
		.vs-con-tbody {
			max-height: 300px;
			// overflow-x: hidden;
			background: #f8f8fa;
			border-color: #f8f8fa !important;
		}

		.vs-table {
			min-width: 320px !important;
			border-collapse: separate;
			border-spacing: 0 1.3rem;
			padding: 0 1rem;

			.vs-progress--background {
				min-width: 79px;
			}
			.vs-progress-warning {
				background: #e8e6e6 !important;
			}

			th.index,
			td.index {
				max-width: 50px !important;
				padding-right: 0 !important;
				padding-left: 15px !important;
			}

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					max-width: 150px;
					padding: 20px 10px;

					&:first-child {
						border-top-left-radius: 0.5rem;
						border-bottom-left-radius: 0.5rem;
					}
					&:last-child {
						border-top-right-radius: 0.5rem;
						border-bottom-right-radius: 0.5rem;
					}
				}
				td.td-check {
					padding: 20px !important;
				}

				&.has-error {
					background: #ffe2e2 !important;
				}
			}
		}

		.vs-table--thead {
			display: none;
		}
	}

	@media (max-width: 500px) {
		.table-anexos-body {
			.index,
			.vs-progress--background,
			.text-enviando-anexo {
				display: none;
			}
		}
	}
}
</style>
